<template>
  <div v-loading="loading">
    <div class="content-item">
      <div class="content-box">
        <el-row :gutter="20">
          <el-col :md="24" :lg="12">
            <el-upload
              action=""
              ref="upload"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
              :limit="1"
              :auto-upload="false"
              :show-file-list="false"
              :disabled="excelLoading"
              :on-change="handleExcel"
              drag
            >
              <i :class="excelLoading ? 'el-icon-loading' : 'el-icon-menu'"></i>
              <div class="el-upload__text">点击此处上传表格</div>
            </el-upload>
          </el-col>
          <el-col :md="24" :lg="12">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-card shadow="never">
                  <div class="demo-tongji">
                    <h1>{{ excelCount }}</h1>
                    <h2>已识别</h2>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="never">
                  <div class="demo-tongji">
                    <h1>{{ excelPost }}</h1>
                    <h2>已完成</h2>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="never">
                  <div class="demo-tongji" :class="excelStatusError ? 'error' : ''">
                    <h1>{{ excelStatusMsg }}</h1>
                    <h2>{{ excelStatus }}</h2>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-button @click="getExcel" class="demo-btn">下载示例表格</el-button>
              </el-col>
              <el-col :span="12">
                <el-button type="primary" @click="post(0)" class="demo-btn" :loading="excelLoading" :disabled="excelLoading">开始批量下单</el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 表格 -->
    <div class="content-item">
      <div class="content-box">
        <el-table
          :data="excelData"
          style="width: 100%"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="发件信息">
                  <span>{{ props.row.nomRte }} - {{ props.row.telefRte }} <br> {{ props.row.pobRte }} {{ props.row.dirRte }} - {{ props.row.codPosNacRte }}</span>
                </el-form-item>
                <el-form-item label="收件信息">
                  <span>{{ props.row.nomDest }} - {{ props.row.telefDest }} <br> {{ props.row.pobDest }} {{ props.row.dirDest }} - {{ props.row.codPosNacDest }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column type="index" label="ID" />
          <el-table-column label="线路" align="center">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.type }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              <el-tag effect="plain">{{ scope.row.crea | creaName }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="保险" align="center">
            <template slot-scope="scope">
              {{ scope.row.seguro }}
            </template>
          </el-table-column>
          <el-table-column label="待收款" align="center">
            <template slot-scope="scope">
              {{ scope.row.reembolso }}
            </template>
          </el-table-column>
          <el-table-column label="包裹信息" align="center">
            <template slot-scope="scope">
              {{ scope.row.bultos[0].kilos }}Kg ({{ scope.row.bultos[0].largo }} * {{ scope.row.bultos[0].ancho }} * {{ scope.row.bultos[0].alto }})
            </template>
          </el-table-column>
          <el-table-column label="需要积分" align="center">
            <template slot-scope="scope">
              <el-link type="danger">{{ scope.row.money }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="状态" fixed="right" widht="200">
            <template slot-scope="scope">
              <el-link :type="scope.row.msgType">{{ scope.row.msg }}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

  </div>
</template>
<script>
import { type, query, order } from '../api/api';

export default {
  name: 'Order',
  metaInfo(){
    return {
      title: '批量下单',
    }
  },
  filters: {
    // 类型名称
    creaName (value) {
      let data = {S: '退包取件', N: '次日达'}
      return  data[value]
    }
  },
  data() {
    return {
      loading: true,
      excelLoading: false,
      excelData: [],
      excelCount: 0,
      excelPost: 0,
      excelStatusMsg: '等待',
      excelStatus: '状态',
      excelStatusError: false,
      type: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    // 国家列表
    getData() {
      type().then(data => {
        this.type = data.type
        this.loading = false
      })
    },
    
    // 状态显示
    statusShow (status, msg, err = false) {
      this.excelStatusMsg = msg
      this.excelStatus = status
      this.excelStatusError = err
    },

    // 判断状态是否有错误
    statusShowError () {
      return this.excelStatusError
    },
    
    // 导入表格
    handleExcel (file) {
      this.excelLoading = true
      // 开始导入
      setTimeout(() => {
        // 清空文件列表
        this.excelData = []
        this.excelCount = 0
        this.excelPost = 0
        this.statusShow('准备导入', '就绪')
        this.$refs.upload.clearFiles()
        // 开始导入
        this.importFile(file).then(data => {
          // 删除提示数据
          data.splice(0, 1)
          // 整理数组并查询价格
          this.query(data)
        })
      }, 500)
    },

    importFile(file) {
      return new Promise(function (resolve) {
        // 文件类
        let reader = new FileReader();

        // 载入文件
        reader.onload = function () {
          let binary = ''
          let bytes = new Uint8Array(reader.result);
          let length = bytes.byteLength;

          // 循环字节
          for(let i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
          }

          // 转为JSON
          const XLSX = require('xlsx');
          const wb = XLSX.read(binary, { type: 'binary' });
          resolve(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]))
        }

        // 读取文件
        reader.readAsArrayBuffer(file.raw);
      })
    },

    // 查询价格
    query (data) {
      // 队列循环
      let value = data.shift()

      // 加载状态消失
      if(!value) {
        this.statusShow('识别完成', '就绪')
        return this.excelLoading = false
      }

      // 整理下单信息
      let order = {
        id: this.type[value['线路']].id,
        type: this.type[value['线路']].name,
        crea: value['类型'],
        seguro: value['保险'],
        reembolso: value['待收款'],
        bultos: [{
          kilos: value['包裹重量'],
          largo: value['包裹长'],
          ancho: value['包裹宽'],
          alto: value['包裹高']
        }],
        nomRte: value['发件姓名'],
        telefRte: value['发件电话'],
        pobRte: value['发件城市'],
        dirRte: value['发件地址'],
        codPosNacRte: value['发件邮编'],
        nomDest: value['收件姓名'],
        telefDest: value['收件电话'],
        pobDest: value['收件城市'],
        dirDest: value['收件地址'],
        codPosNacDest: value['收件邮编'],

        money: '',
        msg: '正在识别',
        msgType: 'primary'
      }
      // 加载表格
      this.excelData.push(order)
      // 获取索引
      let index = this.excelData.length - 1
      // 状态
      this.statusShow('正在识别', (index + 1) + '行')

      // 查询价格
      query(order).then(res => {
        if(res.err) {
          this.excelData[index].msg = res.msg
          this.excelData[index].msgType = 'danger'
          
          this.statusShow('识别错误', (index + 1) + '行', true)
          return this.excelLoading = false
        }
        
        this.excelData[index].msg = '等待下单'
        this.excelData[index].msgType = 'warning'
        this.excelData[index].money = res.money
        // 导入 + 1
        this.excelCount++
        // 继续循环
        this.query(data)
      })
    },

    // 开始下单
    post (index) {
      if (this.statusShowError()) {
        return this.$message.error('请修正表格中的数据再进行批量下单')
      }
      this.excelLoading = true
      this.excelPost = 0
      this.postHandle(index)
    },
    // 下单循环
    postHandle (index) {
      // 检查存在
      if(this.excelData.length == index) {
        this.statusShow('下单完成', '就绪')
        return this.excelLoading = false
      }

      // 改变订单状态
      this.excelData[index].msg = '正在下单'
      this.excelData[index].msgType = 'success'
      this.statusShow('正在下单', (index + 1) + '行')

      // 开始请求
      order(this.excelData[index]).then(data => {
        if(data.err) {
          // 记录错误停止
          this.excelData[index].msg = data.msg
          this.excelData[index].msgType = 'danger'
          
          this.statusShow('下单错误', (index + 1) + '行', true)
          return this.excelLoading = false
        }

        // 下单成功
        this.excelData[index].msg = data.code
        this.excelPost++
        this.postHandle(index + 1)
      })
    },
    // 下载示例
    getExcel () {
      window.open('/app/cex/导入表格示例.xlsx')
    }
  },
}
</script>
<style lang="scss">
@import "../style/style";
.el-upload{
  width: 100%
}
.el-upload-dragger{
  width: 100%;

  .el-icon-menu{
    font-size: 67px;
    color: $--color-primary;
    margin: 40px 0 16px;
    line-height: 50px;
    opacity: .5;
  }
  .el-icon-loading{
    @extend .el-icon-menu
  }
}
.demo-table-expand {
    font-size: 0;
    label {
      width: 90px;
      color: #99a9bf;
    }
    .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 49%;
    }
    .el-form-item__content{
      width: 100%;
    }
}
</style>
<style lang="scss" scoped>
@import "../style/style";
.demo-tongji{
  text-align: center;

  h1{
    font-size: 25px;
    font-weight: normal;
    margin: 0.5em 0;
  }
  h2{
    font-size: 12px;
    color: #99a9bf;
    font-weight: normal;
    margin-top: 0
  }

  &.error{
    h1{
      color: $--color-danger
    }
    h2{
      color: $--color-danger
    }
  }
}
.demo-btn{
  width: 100%;
  margin-top: 20px;
}
</style>